import type { ComplexStyleRule } from '@vanilla-extract/css';

export const breakpoints = {
    xs: 0,
    sm: 320,
    md: 768,
    lg: 992,
    xl: 1280,
    xxl: 1600,
} as const;

export const breakpointNames = Object.keys(breakpoints) as Breakpoint[];

export const breakpointQueries = {
    xs: 'screen',
    sm: `screen and (min-width: ${breakpoints.sm}px)`,
    md: `screen and (min-width: ${breakpoints.md}px)`,
    lg: `screen and (min-width: ${breakpoints.lg}px)`,
    xl: `screen and (min-width: ${breakpoints.xl}px)`,
    xxl: `screen and (min-width: ${breakpoints.xxl}px)`,
} as const;

export type Breakpoint = keyof typeof breakpoints;

type BreakpointStyles = {
    xs?: ComplexStyleRule;
    sm?: ComplexStyleRule;
    md?: ComplexStyleRule;
    lg?: ComplexStyleRule;
    xl?: ComplexStyleRule;
    xxl?: ComplexStyleRule;
};

export const media = ({ sm, md, lg, xl, xxl }: BreakpointStyles): ComplexStyleRule => {
    if (!sm && !md && !lg && !xl) {
        return {};
    }

    return {
        '@media': {
            ...(sm && { [breakpointQueries.sm]: sm }),
            ...(md && { [breakpointQueries.md]: md }),
            ...(lg && { [breakpointQueries.lg]: lg }),
            ...(xl && { [breakpointQueries.xl]: xl }),
            ...(xxl && { [breakpointQueries.xxl]: xxl }),
        },
    } as ComplexStyleRule;
};
